import { useQuery } from '@tanstack/react-query';
import { aiAPI } from '../services/api';

/** Available AI models for the current user, sorted by the backend (PDR-002). */
export function useAvailableModels() {
  return useQuery({
    queryKey: ['ai-models'],
    queryFn: () => aiAPI.getAvailableModels().then((r) => r.data.models),
    staleTime: 5 * 60 * 1000,
  });
}
